import { useAuth, useUserAccess } from '@/hooks/auth';
import { UpcomingReminders } from '@/components/dashboard/reminders/UpcomingReminders';
import { RecentMentions } from '@/components/dashboard/mentions/RecentMentions';
import { UpcomingMilestones } from '@/components/dashboard/milestones/UpcomingMilestones';
import InsightMetrics from '@/components/dashboard/insights/InsightMetrics';

export default function DashboardContent() {
  const { userMetadata } = useAuth();
  const userAccess = useUserAccess();
  const displayName = (userMetadata?.data?.displayName as string) || '';
  const adminUser = Boolean(userAccess?.admin);

  return (
    <div className='flex flex-col items-center justify-center md:px-6 md:py-2 lg:px-12 lg:py-4 xl:px-16 xl:py-8'>
      <div className='flex w-full flex-col items-start justify-center'>
        <div className='flex w-full flex-col items-start justify-center px-3 py-2'>
          <p className='text-xl text-[#52525B]'>Welcome back, {displayName}</p>
        </div>
      </div>
      {adminUser && (
        <div className='w-full py-2'>
          <InsightMetrics />
        </div>
      )}
      <div className='grid w-full grid-cols-1 gap-4 py-2 sm:grid-cols-2 lg:grid-cols-3'>
        <UpcomingReminders />
        <RecentMentions />
        <UpcomingMilestones />
      </div>
    </div>
  );
}
